import { render, staticRenderFns } from "./CreateAccountForwarderModal.vue?vue&type=template&id=db1eb20e&"
import script from "./CreateAccountForwarderModal.vue?vue&type=script&lang=js&"
export * from "./CreateAccountForwarderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db1eb20e')) {
      api.createRecord('db1eb20e', component.options)
    } else {
      api.reload('db1eb20e', component.options)
    }
    module.hot.accept("./CreateAccountForwarderModal.vue?vue&type=template&id=db1eb20e&", function () {
      api.rerender('db1eb20e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/CreateAccountForwarderModal.vue"
export default component.exports